import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { VueFactureVenteFicheContenuComponent } from '../vue-facture-vente-fiche-contenu/vue-facture-vente-fiche-contenu.component';
import { BarreMenusComponent, DonneesMenuItem, SimpleLibelleComponent } from '../../../../../../../val-ammon-composants/val-composants-lib/src/public-api';
import { ServicesParametresClient } from '../../../../../../../val-definitions-communes-lib/src/public-api';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe} from '@angular/common';

// Composant page pour afficher la fiche de vente directement via URL
@Component(
  {
    selector: 'val-facture-vente-page',
    imports: [
      VueFactureVenteFicheContenuComponent,
      SimpleLibelleComponent,
      AsyncPipe,
      BarreMenusComponent
    ],
    templateUrl: './vue-facture-vente-page.component.html',
    styleUrls: ['./vue-facture-vente-page.component.scss']
  })
export class VueFactureVentePageComponent {

  // Contenu de la fiche
  @ViewChild("ficheContenu")
  set ficheContenu(value: VueFactureVenteFicheContenuComponent | undefined) {
    if (!value) 
      return;
    this.ficheContenuComponent = value;
    queueMicrotask(() => {
      const venteId = this.route.snapshot.params['id'];
      value.ChargerDonnees(venteId);
    });
  }
  private ficheContenuComponent: VueFactureVenteFicheContenuComponent | undefined;

  // Indique si l'initialisation est terminée
  public initialisationTermine$: BehaviorSubject<boolean>;

  constructor(private route: ActivatedRoute, private servicesParametresClient: ServicesParametresClient) {
		this.initialisationTermine$ = new BehaviorSubject<boolean>(false);
  }

  async ngOnInit(): Promise<void> {
    await this.servicesParametresClient.ChargerParametresClient();

    this.initialisationTermine$.next(true);
  }

  public titre(): string {
    return this.ficheContenuComponent?.donnees?.titre ?? '';
  }

  public menuItems(): DonneesMenuItem[] {
    return this.ficheContenuComponent?.menuItems && !this.ficheContenuComponent.AucuneDonnee() ? this.ficheContenuComponent.menuItems : [];
  }
}
